import { render, staticRenderFns } from "./dispatch-order.vue?vue&type=template&id=70c5ad30&scoped=true&"
import script from "./dispatch-order.vue?vue&type=script&lang=js&"
export * from "./dispatch-order.vue?vue&type=script&lang=js&"
import style0 from "./dispatch-order.vue?vue&type=style&index=0&id=70c5ad30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c5ad30",
  null
  
)

export default component.exports